<svg id="barcode">
</svg>